const menu = {
  igp: [
    {
      path: "/",
      tag: "Inicio",
      name: "home",
    },
    {
      tag: "Acerca del IGP",
      children: [
        {
          path:
            "https://www.gob.pe/4142-instituto-geofisico-del-peru-que-hacemos",
          tag: "Que hacemos",
          name: "subp1",
        },
        {
          path:
            "https://www.gob.pe/8304-instituto-geofisico-del-peru-organizacion-de-instituto-geofisico-del-peru",
          tag: "Organización",
          name: "subp2",
        },
        {
          path: "https://www.gob.pe/institucion/igp/funcionarios",
          tag: "Funcionarios",
          name: "subp3",
        },
        {
          path: "/normativas",
          tag: "Normativas",
          name: "subp4",
        },
      ],
    },
    {
      tag: "Programas de investigación",
      children: [
        {
          path:
            "http://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-tierra-solida/",
          tag: "Ciencias de la tierra sólida",
        },
        {
          path:
            "http://www.igp.gob.pe/programas-de-investigacion/ciencias-de-la-atmosfera-e-hidrosfera/",
          tag: "Ciencias de la Atmósfera, Hidrosfera y Cambio Climático",
        },
        {
          path:
            "http://www.igp.gob.pe/programas-de-investigacion/ciencias-del-geoespacio-y-astronomia/",
          tag: "Ciencias del Geoespacio",
        },
      ],
    },
    {
      tag: "Servicios",
      children: [
        {
          path: "https://www.igp.gob.pe/servicios/centro-sismologico-nacional/",
          tag: "Centro Sismológico Nacional",
        },
        {
          path:
            "https://www.igp.gob.pe/servicios/centro-vulcanologico-nacional/",
          tag: "Centro Vulcanológico Nacional",
        },
        {
          path:
            "https://www.igp.gob.pe/servicios/centro-monitoreo-deslizamientos-huaicos/",
          tag: "Centro de Monitoreo de Deslizamientos y Huaicos",
        },
      ],
    },
    /*     {
      path: "/Observatorio",
      tag: "Observatorios",
      name: "about"
    }, */
  ],
  cah: [
    {
      path: "/",
      tag: "Inicio",
      name: "home",
    },
    {
      path: "/acerca-de",
      tag: "Acerca de",
      name: "about",
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/oscilacion-sur",
          tag: "El Niño - Oscilación del Sur (ENSO)",
          name: "subp1",
        },
        {
          path: "/subprogramas/variabilidad-cambio-climatico",
          tag: "Variabilidad y Cambio Climático en el Perú",
          name: "subp2",
        },
        {
          path: "/subprogramas/eventos-meteorologicos-hidroclimaticos",
          tag: "Eventos meteorológicos e hidroclimáticos extremos",
          name: "subp3",
        },
      ],
    },
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1",
        },
        {
          path: "/proyectos/tecnologico",
          tag: "Proyectos de Desarrollo Tecnológico",
          name: "project2",
        },
      ],
    },
    {
      tag: "Laboratorios",
      children: [
        {
          path: "/laboratorio/dinamica/acerca-de",
          tag: "Dinámica de Fluídos Geofísicos Computacional",
          name: "lab1",
          children: [
            {
              path: "/laboratorio/dinamica/modelado-numerico",
              tag: "Inicio del Modelado Numérico en el IGP",
              name: "model",
            },
            {
              path: "/laboratorio/dinamica/hpc-linux-cluster",
              tag: "HPC-LINUX-CLUSTER",
              name: "cluster",
            },
            {
              path: "/laboratorio/dinamica/recursos",
              tag: "Acceso a Nuestros Recursos",
              name: "resources",
            },
            {
              path: "/laboratorio/dinamica/investigaciones",
              tag: "Investigaciones",
              name: "research",
            },
          ],
        },
        {
          tag: "Microfísica Atmosférica y Radiación",
          path: "/laboratorio/microfisica/acerca-de",
          name: "lamar",
          children: [
            {
              path: "/laboratorio/microfisica/instrumentos",
              tag: "Instrumentos",
              name: "tools",
            },
            {
              path: "/laboratorio/microfisica/monitoreo",
              tag: "Monitoreo Lamar",
              name: "monitoring",
            },
            {
              path: "/laboratorio/microfisica/acceso-a-datos",
              tag: "Acceso a los Datos",
              name: "data",
            },
            {
              path: "/laboratorio/microfisica/investigaciones",
              tag: "Investigaciones",
              name: "research",
            },
          ],
        },
      ],
    },
    {
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/55",
      tag: "Publicaciones",
      name: "publications",
    },
  ],
  cts: [
    {
      path: "/",
      tag: "Inicio",
      name: "home",
    },
    {
      path: "/acerca-de",
      tag: "Acerca de",
      name: "about",
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/procesos-dinamica-interna",
          tag: "Procesos de Dinámica Interna",
          name: "subp1",
        },
        {
          path: "/subprogramas/procesos-fisicos-suelos",
          tag: "Procesos Físicos de los Suelos",
          name: "subp2",
        },
      ],
    },
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1",
        },
        {
          path: "/proyectos/tecnologico",
          tag: "Proyectos de Desarrollo Tecnológico",
          name: "project2",
        },
      ],
    },
    {
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/58",
      tag: "Publicaciones",
      name: "publications",
    },
    {
      path: "/glosario",
      tag: "Glosario",
      name: "glosary",
    },
  ],
  cga: [
    {
      path: "/",
      tag: "Inicio",
      name: "home",
    },
    {
      path: "/acerca-de",
      tag: "Acerca de",
      name: "about",
    },
    {
      tag: "Subprogramas",
      children: [
        {
          path: "/subprogramas/aeronomia-clima-espacial",
          tag: "Aeronomía y Clima Espacial",
          name: "subp1",
        },
        {
          path: "/subprogramas/meteoros-objetos-espaciales",
          tag: "Meteoros y Objetos Espaciales",
          name: "subp2",
        },
        {
          path: "/subprogramas/astronomia",
          tag: "Astronomía",
          name: "subp3",
        },
      ],
    },
    {
      tag: "Proyectos",
      children: [
        {
          path: "/proyectos/investigacion",
          tag: "Proyectos de Investigación",
          name: "project1",
        },
        {
          path: "/proyectos/tecnologico",
          tag: "Proyectos de Desarrollo Tecnológico",
          name: "project2",
        },
      ],
    },
    {
      path: "https://repositorio.igp.gob.pe/handle/20.500.12816/56",
      tag: "Publicaciones",
      name: "publications",
    },
    {
      path: "/glosario",
      tag: "Glosario",
      name: "glosary",
    },
  ],
};
const trail = [
  {
    path: "https://www.gob.pe/igp",
    tag: "Portal IGP",
    name: "portal",
  },
  {
    path: "/",
    tag: process.env.VUE_APP_TITLE,
    name: "root",
  },
];
const dynamicTrail = [
  {
    tag: "Subprogramas",
    path: "/subprogramas",
  },
  {
    tag: "Proyectos",
    path: "/proyectos",
  },
];
function getMenu(program) {
  return menu[program] || "cts";
}
function getTrail() {
  return trail;
}
function getDynamicTrail() {
  return dynamicTrail;
}
export { getMenu, getTrail, getDynamicTrail };
